import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

export interface LazyModuleConfig {
  path: string;
  loadChildren: () => Promise<any>;
  preload?: boolean;
  priority?: number;
}

@Injectable({
  providedIn: 'root'
})
export class LazyLoadingService {
  private router = inject(Router);

  private moduleConfigs: LazyModuleConfig[] = [];
  setModuleConfigs(moduleConfigs: LazyModuleConfig[]): void {
    this.moduleConfigs = moduleConfigs;
  }

  getModuleConfigs(): LazyModuleConfig[] {
    return this.moduleConfigs.sort((a, b) => (a.priority || 0) - (b.priority || 0));
  }

  getPreloadModules(): LazyModuleConfig[] {
    return this.moduleConfigs.filter(config => config.preload);
  }

  async preloadModule(config: LazyModuleConfig): Promise<void> {
    try {
      await config.loadChildren();
      //console.log(`Module ${config.path} preloaded successfully`);
    } catch (error) {
      console.error(`Failed to preload module ${config.path}:`, error);
    }
  }

  async preloadAllModules(): Promise<void> {
    const preloadModules = this.getPreloadModules();
    const preloadPromises = preloadModules.map(config => this.preloadModule(config));
    await Promise.all(preloadPromises);
  }
}
